import React, { useState } from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import {
  useChartSessionLogs,
  CHART_SESSION_LOGS_PER_PAGE,
} from 'infrastructure/hooks/logs/use-chart-session-logs';

import { logsColumns } from './columns';

import type { DateRange } from 'infrastructure/types';

interface IChartSessionLogProps {
  patientGuid: string;
  dateRange?: DateRange;
}

const ChartSessionLog: React.FC<IChartSessionLogProps> = (props) => {
  const [page, setPage] = useState(1);
  const { patientGuid, dateRange } = props;

  const { data, isLoading, isFetching } = useChartSessionLogs({
    patientGuid,
    page,
    dateRange,
  });

  const columns = logsColumns();

  return (
    <BaseTableNew
      rowKey={(r) => new Date(r.sessionStart).getTime().toString()}
      dataCy="chart-session-status-log-table"
      columns={columns}
      items={data?.data || []}
      loading={isLoading || isFetching}
      pagination={{
        current: page,
        pageSize: CHART_SESSION_LOGS_PER_PAGE,
        total: data?.count || 0,
        position: ['bottomCenter'],
      }}
      onChangePage={setPage}
      bordered
    />
  );
};

export default ChartSessionLog;
